import { IAdvertiserFormData, IAdvertiserFormDataErrors } from "advertiser/model"
import { translate } from "app/language/service"
import { advertiserExistsByName } from "./common"

export function validateAdvertiserFormData(data: IAdvertiserFormData): IAdvertiserFormDataErrors {
  const errors: IAdvertiserFormDataErrors = {}
  if (!data.name) {
    errors.name = translate("label.field.required")
  } else if (advertiserExistsByName(data.name, data.id)) {
    errors.name = translate("advertiser.name.already.exist", data.name)
  }
  if (typeof data.media_fee_percent === "number") {
    if (data.media_fee_percent < 0) {
      errors.media_fee_percent = translate("label.field.greater.than.or.equals", 1)
    } else if (data.media_fee_percent > 100) {
      errors.media_fee_percent = translate("label.field.lower.than.or.equals", 100)
    }
  }
  return errors
}
